/* eslint-disable react/no-array-index-key */
import React from 'react';
import classNames from 'classnames';
import {
    FaLaptop,
    FaFacebookF,
    FaInstagram,
    FaPinterest,
    FaTiktok,
    FaTwitter,
} from 'react-icons/fa';
import styles from './teamMemberDescription.module.scss';

interface ITeamMemberDescription {
    contenu: {
    type: string;
    id: number;
    nom: string;
    slug: string;
    description: string;
    imageUrl: string;
    urls: ({
        adresse: string;
        type: string;
        addresse?: undefined;
    } | {
        addresse: string;
        type: string;
        adresse?: undefined;
    })[];
};
    idDescription?: number;

}

const TeamMemberDescription = ({contenu, idDescription}: ITeamMemberDescription) => {
    const {description, id, urls} = contenu;

    const renderIcon = (type: string) => {
        switch (type) {
        case 'siteWeb':
            return <FaLaptop aria-labelledby={`id-${type}`} />;
        case 'facebook':
            return <FaFacebookF aria-labelledby={`id-${type}`} />;
        case 'instagram':
            return <FaInstagram aria-labelledby={`id-${type}`} />;
        case 'twitter':
            return <FaTwitter aria-labelledby={`id-${type}`} />;
        case 'pinterest':
            return <FaPinterest aria-labelledby={`id-${type}`} />;
        case 'tiktok':
            return <FaTiktok aria-labelledby={`id-${type}`} />;
        default:
            break;
        }
        return false;
    };

    return (
        id === idDescription
        && description
        && (
            <div data-component="TeamMemberDescription" className={classNames(styles.me)}>
                <p>{description}</p>
                {urls && urls.length > 0 && (
                    <>
                        <hr />
                        <ul className={styles.socials}>
                            {urls.map((url, index) => (
                                <li key={index} className={styles.social}>
                                    <a
                                        id={`id-${url.type}`}
                                        aria-label={url.type}
                                        href={url.adresse}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <span>{renderIcon(url.type)}</span>
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </>
                )}
            </div>
        )
    );
};

export default TeamMemberDescription;
